import request from "@/hooks/useRequest";

// 遗留用户kyc身份证明信息提交
export const postKycLegacyIdentificationApi = (body) => {
  return request("/web-wallet/api/v1/kyc/legacy/identification", { body });
};

// 获取遗留用户kyc进程信息
export const getKyvLegacyProcessInfo = (params) => {
  return request("/web-wallet/api/v1/kyc/legacy/process-info", { params });
};

// 遗留用户数币白名单新增
export const postWhiteListLegacyUserCreatenApi = (body) => {
  return request("/web-wallet/api/v1/whitelist/legacy-user/create", { body });
};

// 遗留用户数币白名单列表
export const getWhiteListLegacyUserList = (params) => {
  return request("/web-wallet/api/v1/whitelist/legacy-user/list", { params });
};
